// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__15Z90","title":"InfoRow_title__BLhan"};